
import {Navbar,Footer} from '../hrcomponents'
import React,{useState} from "react";
import * as Icon from "react-bootstrap-icons";
import {Outlet, useNavigate } from "react-router-dom";
import modules from '../utils/modules.json';

function Home() {
  const navigate = useNavigate();

  if(localStorage.getItem('branchID')===null){
    window.location.replace('/');
  }

  const userAccess = JSON.parse(
  localStorage.getItem("userAccess") || "[]"
  );
  
    // const modules = [
      
    //     {
    //       moduleName: "ATTENDANCE",
    //       icon: <Icon.CalendarCheck />,
    //       menus: [
    //         { name: "Dashboard", icon: <Icon.Speedometer />, path:"hrDashboard" },
    //         { name: "Attendance Summary", icon: <Icon.DatabaseFillAdd />, path:"attnReport" },
    //         { name: "Late Attendance", icon: <Icon.Bullseye  />, path:"lateAttendance" },
    //         { name: "Attendance Register", icon: <Icon.BarChartLineFill  />, path:"attenRegister" },
    //         { name: "Attendance Adjustment", icon: <Icon.Calendar2Check  />, path:"attendanceAdjustment" },
    //         {name:"Leave", icon:< Icon.CalendarPlus/>, path:"leave"},
    //       ],
    //     },
    //     {
    //       moduleName:"EMPLOYEE INFO",
    //       icon:<Icon.PeopleFill/>,
    //       menus: [
    //         { name: "Employee Info", icon: <Icon.PersonVcard />, path:"employeeInfo" },
    //         { name: "Transfer", icon: <Icon.PersonDash /> },
    //         { name: "Promotion", icon: <Icon.PersonUp /> },
    //       ],
    //     },
      
    //     {
    //       moduleName: "ACR",
    //       icon: <Icon.GearFill />,
    //       menus: [
    //         { name: "DOCR", icon: <Icon.GearFill />, path:"docr" },
    //       ],
    //     },
    //   ];
      const [activeMenu, setActiveMenu] = useState("Dashboard");
      const [openModule, setOpenModule] = useState("ATTENDANCE");
    
      const toggleModule = (moduleName) => {
        setOpenModule(openModule === moduleName ? "" : moduleName);
      };

      const [collapsed, setCollapsed] = useState(false);

  return (
    <>
    <div className="container-fluid" style={{marginTop:75}}>

  <Navbar />

  <div className="d-flex" >

    {/* SIDEBAR */}
    <div
      style={{
        minHeight: "100vh",
        background: "#1e293b",
        color: "white",
        width: collapsed ? "70px" : "260px",
        transition: "0.3s",
      }}
    >

      {/* Header */}
      <div className="p-3 d-flex justify-content-between align-items-center border-bottom" style={{ background: "#0f172a" }}>
        {!collapsed && <h5 className="m-0">Human Resource & Information System</h5>}

        <button
          onClick={() => setCollapsed(!collapsed)}
          style={{ background: "none", border: "none", color: "white" }}
        >
          {collapsed ? "☰" : "✕"}
        </button>
      </div>

      {/* MENU */}
      <div className="p-2">
      
              {modules.HRIS.menue.map((module, index) =>{
              const MenuIcon = Icon[module.icon];
              return (
                <div key={index}>
                  <div className="p-2 d-flex align-items-center gap-2" onClick={() => toggleModule(module.moduleName)}
                    style={{ 
                      cursor: "pointer",
                      background:  openModule === module.moduleName ? "#334155" : "transparent", }}
                  >
                    {MenuIcon && <MenuIcon className="me-2"/>}
                    {!collapsed && module.moduleName}  
                  </div>
      
                  {!collapsed && openModule === module.moduleName && (
                  <div className="ms-3 mt-2">
                    {userAccess
                      .filter(item => item.formGroup === module.moduleName)
                      .map(menu =>(
                      <div
                        key={menu.formName}
                        className="p-2 mb-1 rounded d-flex align-items-center gap-2 rounded"
                        style={{
                          cursor: menu.isEnabled==='Y' ? "pointer" : "not-allowed",
                          background: activeMenu === menu.formName ? "#2563eb" : "transparent",
                          opacity: menu.isEnabled==='Y' ? 1 : 0.5,
                        }}
                        onClick={() => 
                          menu.isEnabled==='Y'
                          ?  ( setActiveMenu(menu.formName), navigate(menu.path,{state: { menu }}))
                          :  ""
                        }
                      >  
                        {< Icon.CaretRightFill/>}        
                        <span>{menu.formName.replaceAll("_", " ")}</span>
                      </div>
                      ))
                    }
                  </div>
                  )}
                </div>
              )}
              )}
      
            </div>
      {/* <div className="p-2">

        {modules.map((module, index) => (
          <div key={index}>

            <div className="p-2 d-flex align-items-center gap-2" onClick={() => toggleModule(module.moduleName)}
              style={{ 
                cursor: "pointer",
                background:
                openModule === module.moduleName ? "#334155" : "transparent", }}
            >
              {module.icon}
              {!collapsed && module.moduleName}  
            </div>

            {!collapsed && openModule === module.moduleName && (
              <div className="ms-3 mt-2">

                {module.menus.map((menu, i) => (
                  <div
                    key={i}
                    className="p-2 mb-1 rounded d-flex align-items-center gap-2"
                    style={{ cursor: "pointer", background: activeMenu === menu.name ? "#2563eb" : "transparent" }}
                    onClick={() => {
                      setActiveMenu(menu.name);
                      navigate(menu.path);
                    }}
                    
                  >
                    {menu.icon} <span>{menu.name}</span>
                  </div>
                ))}

              </div>
            )}

          </div>
        ))}

      </div> */}

    </div>

    {/* MAIN BODY */}
    <div style={{ flex: 1, minHeight: "100vh" }}>
      <Outlet />
    </div>

  </div>

  <Footer />

</div>

    </>
  )
}

export default Home